import gql from 'graphql-tag';

import { ContentOperationsFragment } from '@confluence/entity-operations/entry-points/EntityOperationsFragment.fragment';

export const ArchivedPageBannerQuery = gql`
	query ArchivedPageBannerQuery($contentId: ID) {
		content(id: $contentId, status: ["archived", "current"]) {
			nodes {
				...ContentOperationsFragment
				archivedContentMetadata {
					archiveNote
				}
				history {
					lastUpdated {
						by {
							... on KnownUser {
								accountId
							}
							... on User {
								accountId
							}
							... on UnknownUser {
								accountId
							}
						}
					}
				}
			}
		}
	}

	${ContentOperationsFragment}
`;
